<template>
  <v-dialog v-model="dialog" width="600">
    <aprobar-suspencion-item
      :movilidad="movilidad"
      v-if="movilidad.id_tipo_justificacion == 2"
    />
  </v-dialog>
</template>

<script>
import AprobarCambioItem from "@/components/admin/persona/components/AprobarCambioItem";
import AprobarMovilidadItem from "../components/AprobarMovilidadItem";
import AprobarSuspencionItem from "../components/AprobarSuspencionItem";
import AprobarRetiro from "../components/AprobarRetiro";
import AprobarComisionServicio from "../components/AprobarComisionServicio";

export default {
  components: {
    AprobarCambioItem,
    AprobarRetiro,
    AprobarComisionServicio,
    AprobarMovilidadItem,
    AprobarSuspencionItem
  },
  data() {
    return {
      dialog: false,

      movilidad: {
        funcionario: {}
      }
    };
  },
  mounted() {
    this.$bus.$on("openDialogSuspencionTipoMovilidad", item => {
      this.movilidad = item;
      this.dialog = true;
    });
    this.$bus.$on("closeDialogAprobar", () => {
      this.close();
    });
  },
  methods: {
    close() {
      this.dialog = false;
      this.movilidad = {
        funcionario: {}
      };
      this.$bus.$emit("closeDialogMovilidad");
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/movilidad/dialogs/SuspencionTipoMovilidad.vue